import * as React from "react";
// Components
import { Popover as FluentPopover, PopoverTrigger, PopoverSurface } from "@fluentui/react-components";
// handler - prevents click propagation from popover surface
const handleClick = (evt)=>{
    evt.stopPropagation();
};
/**
 * Popover control that wraps Fluent UI v9 Popover with trigger and surface as props
 */ export function Popover(props) {
    const { trigger, children, className, ...passThroughProps } = props;
    return /*#__PURE__*/ React.createElement(FluentPopover, passThroughProps, /*#__PURE__*/ React.createElement(PopoverTrigger, {
        disableButtonEnhancement: true
    }, /*#__PURE__*/ React.isValidElement(trigger) ? trigger : /*#__PURE__*/ React.createElement("span", null, trigger)), /*#__PURE__*/ React.createElement(PopoverSurface, {
        className: className,
        onClick: handleClick
    }, children));
}
